export const multiFieldsList = [
  'prefixGroupsUniqueIds',
  'gendersUniqueIds',
  'organisationCategoriesUniqueIds',
  'organizationTypesUniqueIds',
  'makes',
  'makesUniqueIds',
  'models',
  'modelsUniqueIds',
  'manufacturers',
  'manufacturersUniqueIds',
  'calibers',
  'calibersUniqueIds',
  'actions',
  'actionsUniqueIds',
  'types',
  'typesUniqueIds',
  'countries',
  'countriesUniqueIds',
  'transactionTypesUniqueIds',
  'compositionsUniqueIds',
  'proofHousesUniqueIds',
  'statesUniqueIds',
  'hostTypesUniqueIds',
  'magnificationsUniqueIds',
  'utilitiesUniqueIds',
  'reticlesUniqueIds',
  'lightColoursUniqueIds',
  'factoriesUniqueIds',
  'functionalTypesUniqueIds',
  'cartridgeCompositionsUniqueIds',
  'coloursOfPrimerSealantUniqueIds',
  'projectileShapesUniqueIds',
  'shotSizesUniqueIds',
  'munitionTypesUniqueIds',
  'munitionVelocitiesUniqueIds',
  'frtTypesUniqueIds',
  'frtMakesUniqueIds',
  'frtModelsUniqueIds',
  'frtManufacturersUniqueIds',
  'componentCapacitiesUniqueIds',
  'calibresUniqueIds',
  'statusesUniqueIds',
  'licenceAuthorityUniqueIds',
  'capacitiesUniqueIds',
  'roleUniquesIds',
  'statuses',
  'accountsUniqueIds',
  'modulesUniqueIds',
  'eventTypesUniqueIds',
  'eventNamesUniqueIds',
  'calibres',
  'calibresUniqueIds',
];
